//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { PanelContext } from '@/contexts/PanelContext';

/**
 * Access the floating-panel registry.  Subscribes only to the panel context,
 * so opening a panel never re-renders consumers of the other slices.
 */
export function usePanels() {
  const context = useContext(PanelContext);
  if (!context)
    throw new Error('usePanels must be used within a PanelProvider');

  return context;
}
